export default __webpack_public_path__ + "static/media/SuperiorOpen.3cb6f1b9.jpg";